// datenschutz.component.ts
import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../services/seo.service';
import { siteConfig } from '../../config/site-config';


@Component({
  selector: 'app-datenschutz',
  standalone: true,
  templateUrl: './datenschutz.component.html',
  styleUrls: ['./datenschutz.component.css']
})
export class DatenschutzComponent implements OnInit{
  readonly contactEmail = siteConfig.contact.email;
  readonly siteHost = siteConfig.legal.siteHost;
  
  constructor(
    private seoService: SeoService,
  ) {}

  currentYear = new Date().getFullYear();

  ngOnInit(): void {
    this.seoService.setTitle('Datenschutzerklärung');
    this.seoService.setDescription('Unsere Datenschutzerklärung erklärt, wie wir mit deinen Daten umgehen und welche Rechte du hast.');
    this.seoService.setCanonicalUrl()
  }
}
